import { render, staticRenderFns } from "./AllocationCompanyDialog.vue?vue&type=template&id=1f1e165f&scoped=true"
import script from "./AllocationCompanyDialog.vue?vue&type=script&lang=js"
export * from "./AllocationCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./AllocationCompanyDialog.vue?vue&type=style&index=0&id=1f1e165f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e165f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1e165f')) {
      api.createRecord('1f1e165f', component.options)
    } else {
      api.reload('1f1e165f', component.options)
    }
    module.hot.accept("./AllocationCompanyDialog.vue?vue&type=template&id=1f1e165f&scoped=true", function () {
      api.rerender('1f1e165f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/AllocationCompanyDialog.vue"
export default component.exports